import { generateKeys } from '../utils';
export const pixelTypes = generateKeys({
    post: {
        value: 'post',
        label: 'POST (server)',
    },
});
export const eventNames = generateKeys({
    register: {
        value: 'register',
        label: 'registration',
    },
    deposit: {
        value: 'deposit',
        label: 'deposit',
    },
});
export const trackingParameterTypes = generateKeys({
    static: {
        value: 'static',
        label: 'static',
    },
});
export const campaignTypes = generateKeys({
    regular: {
        value: 'regular',
        label: 'Regular',
        isAffiliate: false,
    },
    ib: {
        value: 'ib',
        label: 'Introducing Broker',
        isAffiliate: false,
    },
    affiliate: {
        value: 'affiliate',
        label: 'Affiliate - Cellxperts',
        isAffiliate: true,
    },
    ftdRetarget: {
        value: 'ftd-retarget',
        label: 'FTD Retarget',
        isAffiliate: false,
    },
    referAFriend: {
        value: 'refer_a_friend',
        label: 'Refer a Friend',
        isAffiliate: true,
    },
    cellxpertSignals: {
        value: 'cellxpertSignals',
        label: 'Cellxpert - Signals',
        isAffiliate: true,
    },
    cellxpertLeads: {
        value: 'cellxpertLeads',
        label: 'Cellxpert - Leads',
        isAffiliate: true,
    },
    cellxpertTradingCup: {
        value: 'cellxpertTradingCup',
        label: 'Cellxpert - Trading Cup',
        isAffiliate: true,
    },
    cellxpertEducation: {
        value: 'cellxpertEducation',
        label: 'Cellxpert - Education',
        isAffiliate: true,
    },
    cellxpertYoutube: {
        value: 'cellxpertYoutube',
        label: 'Cellxpert - Youtube',
        isAffiliate: true,
    },
    cellxpertComparisonWebsite: {
        value: 'cellxpertComparisonWebsite',
        label: 'Cellxpert - Comparison Website',
        isAffiliate: true,
    },
    cellxpertMobile: {
        value: 'cellxpertMobile',
        label: 'Cellxpert - Mobile',
        isAffiliate: true,
    },
});
export const campaignMt4Groups = generateKeys({
    aff01: {
        value: 'AFF01',
        label: 'Affiliate Special Group 1',
    },
    aff02: {
        value: 'AFF02',
        label: 'Affiliate Special Group 2',
    },
});
export const campaignCategories = generateKeys({
    directMarketing: {
        value: 'direct_marketing',
        label: 'Direct marketing',
        weight: 0.1,
        order: 1,
    },
    new: {
        value: 'new',
        label: 'New',
        weight: 0.15,
        order: 2,
    },
    topPerforming: {
        value: 'top_performing',
        label: 'Top performing',
        weight: 0.6,
        order: 3,
    },
    organic: {
        value: 'organic',
        label: 'Organic',
        weight: 0.15,
        order: 4,
    },
    other: {
        value: 'other',
        label: 'Other',
        weight: 0,
        order: 5,
    },
});
